import getPage from './page';

const defaultBindings = [];

const getPageBindings = (rootState, pageId) =>
  getPage(rootState, pageId)?.bindings || defaultBindings;

export default getPageBindings;
